import { render, staticRenderFns } from "./AddRedeemModal.vue?vue&type=template&id=3e5ef44e&"
import script from "./AddRedeemModal.vue?vue&type=script&lang=js&"
export * from "./AddRedeemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports